import React from 'react';
import Icon from '../../../components/AppIcon';

const GoalSelectionCard = ({ 
  goal, 
  isSelected, 
  onSelect 
}) => {
  return (
    <button
      onClick={() => onSelect(goal?.id)}
      className={`w-full p-6 rounded-xl border-2 transition-smooth text-left ${
        isSelected
          ? 'border-primary bg-primary/5 elevation-md' :'border-border hover:border-primary/50 hover:elevation-sm'
      }`}
    >
      <div className="flex items-start gap-4">
        <div
          className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 transition-smooth ${
            isSelected
              ? 'bg-primary text-primary-foreground'
              : 'bg-muted text-muted-foreground'
          }`}
        >
          <Icon
            name={goal?.icon}
            size={24}
            color={isSelected ? 'var(--color-primary-foreground)' : 'currentColor'}
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-2">
            {goal?.title}
          </h3>
          <p className="text-sm text-muted-foreground font-body line-clamp-2">
            {goal?.description}
          </p>
        </div>
        {isSelected && (
          <Icon
            name="CheckCircle2"
            size={20}
            color="var(--color-primary)"
            className="flex-shrink-0"
          />
        )}
      </div>
    </button>
  );
};

export default GoalSelectionCard;